module.exports = __webpack_public_path__ + "static/media/delete.54082721.mp3";